// do these things only once
// even if you are using a history.js navigation

// imports --------------------------------------------------------------------
import Fader from '../js_vendor/Fader.js';
import FoldOut from '../js_vendor/FoldOut.js';
import AnimateIt from '../js_vendor/AnimateIt.js';
import Split from '../js_vendor/Split.js';

import * as Vars from './0-vars.js';
import * as Resize from './4-resize.js';
import * as Scroll from './5-scroll.js';

// set user variables ---------------------------------------------------------
const vtDuration = Vars.transitionSlow * 1; // also change in view-transitions css

// set code variables ---------------------------------------------------------
export let transitionDelay;

export let fader;
export let foldOut;
export let animator;
export let smoothScrollInactive;
export let aim;
export let splitter;

export let pageTypePrev = sessionStorage.getItem('pageType');
document.body.setAttribute('data-pagetype-prev', pageTypePrev);
sessionStorage.setItem('pageType', $pageType);

// local variables ------------------------------------------------------------
const browserColorEl = document.querySelector('.bg--1');


// once function --------------------------------------------------------------
export const initOnce = () => {
  // console.log('once', window.blPageTransition ? 'view-transition' : 'no view-transition');

  // safari delay should be after VT duration, because css transitions are buggy during VT
  splitter = new Split({
    charHolderSelector: '.intro__title, .title-btn__title',
    wordHolderSelector: '.event__desc-title-text, .single__desc-title',
    charTiming: { delay: 200, stagger: 30 },
    wordTiming: { delay: 200, stagger: 100 },
    lineTiming: { delay: 200, stagger: 200 },
    textClass: 'fader fader--force fader--up fader--repeat',
    imgClass: 'fader fader--force fader--loader fader--repeat',
  });
  
  transitionDelay = Vars.blSafari ? vtDuration : vtDuration - 200; // 200 before last transition end is kinda nice. Fixes safari css transition issue

  // add Fader
  fader = new Fader({
    // mobileMq: '(orientation: portrait)',
    // fadeDur: 1000,
    // preFadeResizeDur: 200,
    // afterLoadFunction: Resize.saveOffsets, 
    inViewFadeDelay: transitionDelay,
    addStaggerToFaderDelay: false, // if true (default), stagger and data-fader-delay are added together
    // fadeHorizontally: true,
    // listenToScroll: false,
  });

  // add FoldOut
  foldOut = new FoldOut({
    name: 'default',
    startCallback: observerBlocker,
    duringCallback: Scroll.setScroll,
    callback: observerUnblocker,
    // closeOthers: false,
    // transitionDuration: 600; // also change _fold-out.scss
    closeInOtherHolders: true,
  });

  // add AnimateIt
  animator = new AnimateIt({
    frameFunction: frameHandler,
  });

  // slow scroll and mouse follower
  if (typeof animator !== 'undefined') {
    // not on firefox if iframes are present
    if (!Vars.blTouch && !Vars.blFirefox) {
    // if (!Vars.blTouch) {
      const initSmoothScroll = () => {
        animator.smoothScroll({
          speed: 0.15,
          bounce: 0.5,
        });
      };

      if (typeof historyCheckWoocommerce === 'function') {
        if (!historyCheckWoocommerce(window.location.href)) initSmoothScroll();
      } else {
        initSmoothScroll();
      }
    }
  }

  smoothScrollInactive = typeof animator === 'undefined' || typeof animator.scroller !== 'object';

  // output name for devvers ----------------------------------
  console.log('%cSite by', 'color: #999; font-size: 16px; font-family: "Arial"; font-weight: bold; text-transform: uppercase;');
  console.log('%cLittle Fragments', 'color: #999; font-size: 24px; font-family: "Arial"; font-weight: bold; text-transform: uppercase;');
};

// functions -------------------------------------------------------------------

// so observers don't call resize while animating, which slows down the animation
export const observerBlocker = () => {
  // console.log('observerBlocker');
  Resize.setBlockResizeObserver(true); 
  if (typeof fader !== 'undefined' && fader) fader.blockResizeObserver = true;
  if (typeof animator !== 'undefined' && animator) animator.blockResizeObserver = true;
};

export const observerUnblocker = () => {
  // console.log('observerUnblocker');  
  Resize.setBlockResizeObserver(false);
  Resize.setResize(true);
  
  if (typeof fader !== 'undefined' && fader) {
    fader.setBlockResizeObserver(false);
    fader.setFaders();
  }
  
  if (typeof animator !== 'undefined' && animator) {
    animator.blockResizeObserver = false;
    animator.resizeHandler(true);
  } 
}

const frameHandler = () => {
  // console.log('frameHandler');

  // browser color, read from whichever .bg/.bg2 is currently visible
  const colorEl = Scroll.activeBgEl || browserColorEl;
  if (colorEl) {
    const background = getComputedStyle(colorEl).getPropertyValue('background-color');
    document.querySelector('meta[name="theme-color"]').setAttribute('content', background);
  }
};
